"use client"

import { ChatbotUIContext } from "@/context/context"
import { HandlerConfig } from "@/lib/realtime/base-subscription-manager"
import { makeChatMessageChangeHandler, makeChatMessageFileItemHandler, makeChatMessageInsertHandler } from "@/lib/realtime/client-handlers/chat-msg-handler"
import { getClientSubscriptionManager } from "@/lib/realtime/client-subscription-manager"
import { supabase } from "@/lib/supabase/browser-client"
import { logError } from "@/utils/errorLogging"
import { createClientLogger } from "@/utils/logger/clientLogger"
import { useContext, useEffect } from "react"

const logger = createClientLogger('utility.chatSubProvider', supabase)

export function ChatSubscriptionsProvider({ children }: { children: React.ReactNode }) {
	const {
		selectedChatIdRef,
		chatMessagesRef,
		setChatMessagesRef,
		setChatFileItemsRef,
	 } = useContext(ChatbotUIContext)

	/**
		Manage the subscription to chat content changes
	 */
	useEffect(() => {
		let handlers: HandlerConfig<any>[] = []

		const initSubs = async () => {
			logger.info(`Intializing chat subscription handlers`)
			const mgr = getClientSubscriptionManager()
			await mgr.initialize()  //would normally not do anything since global starts first

			handlers = [
				makeChatMessageChangeHandler(setChatMessagesRef),
				makeChatMessageFileItemHandler(chatMessagesRef, setChatMessagesRef, setChatFileItemsRef),
				makeChatMessageInsertHandler(selectedChatIdRef, setChatMessagesRef)
			]
			logger.info(`Registering ${handlers.length} handlers`)
			await Promise.all(
				handlers.map(handler => mgr.registerHandler(handler))
			)
		}

		initSubs().catch(error => {
			logError(logger, error, "Error during init chat context subscriptions")
		})

		return () => {
			logger.info(`Unregistering ${handlers.length} handlers`)
			const mgr = getClientSubscriptionManager()
			void (async () => {
				await Promise.all(
					handlers.map(handler => mgr.unregisterHandler(handler.key))
				)
			})()
		}
	}, [])

  return (
	 	<>
			{children}
		</>
  )
}